export interface EolaMember {
  profileImageUrl: string
  backgroundUrl: string
  name: string

  // Roles by alphabetical order
  role:
    | 'Account Executive'
    | 'CEO and founder'
    | 'CTO and founder'
    | 'Partner success'
    | 'Marketing Executive'
    | 'Senior rails developer'
    | 'Technical lead developer'

  // Origins by alphabetical order
  origin:
    | 'Bath, UK'
    | 'Bracknell, UK'
    | 'Brighton, UK'
    | 'Brussels, Belgium'
    | 'Cambridge, UK'
    | 'Cardiff, UK'
    | 'Cornwall, UK'
    | 'Dhaka, Bangladesh'
    | 'Edinburgh, UK'
    | 'Essex, UK'
    | 'Faversham, UK'
    | 'Gabes, Tunisia'
    | 'Hertfordshire, UK'
    | 'Iran'
    | 'Kent, UK'
    | 'Lisbon, PT'
    | 'London, UK'
    | 'Londrina, Brazil'
    | 'Malmo, Sweden'
    | 'Milton Keynes, UK'
    | 'Mittagong, Australia'
    | 'Portsmouth, UK'
    | 'Sharjah, UAE'
    | 'Sofia, Bulgaria'
    | 'Spalding, UK'
    | 'Suffolk, UK'
    | 'Torfaen, Wales'
    | 'Valenca do Minho, PT'
    | 'Zimbabwe'

  // Activities by alphabetical order
  favouriteActivityType:
    | 'Archery'
    | 'Biking'
    | 'Canoeing'
    | 'Canyoning'
    | 'Climbing'
    | 'Coasteering'
    | 'Fishing'
    | 'Hiking'
    | 'Horse riding'
    | 'Hot air balloon'
    | 'Kayaking'
    | 'Kitesurfing'
    | 'Paddleboarding'
    | 'Quadbiking'
    | 'Sailing'
    | 'Skiing'
    | 'Surfing'
    | 'Trail running'
    | 'White water rafting'
    | 'Yoga'
}

export const FoundersData: EolaMember[] = [
  {
    profileImageUrl: 'v1624963246/eola/public_images/callum-headshot.jpg',
    backgroundUrl: 'v1625041976/eola/public_images/callumcardbackground.png',
    name: 'Callum',
    role: 'CEO and founder',
    origin: 'Cambridge, UK',
    favouriteActivityType: 'Surfing'
  },

  {
    profileImageUrl: 'v1624963411/eola/public_images/dan-headhshot.jpg',
    backgroundUrl: 'v1625042040/eola/public_images/dancardbackground.png',
    name: 'Dan',
    role: 'CTO and founder',
    origin: 'London, UK',
    favouriteActivityType: 'Skiing'
  }
]

export const TeamMemberData: EolaMember[] = [
  {
    profileImageUrl: 'v1624964497/eola/public_images/simon-headshot.jpg',
    backgroundUrl: 'v1625835678/eola/public_images/simon-background.png',
    name: 'Simon',
    role: 'Technical lead developer',
    origin: 'Bracknell, UK',
    favouriteActivityType: 'Archery'
  },
  {
    profileImageUrl: 'v1624963726/eola/public_images/graham-headshot.jpg',
    backgroundUrl: 'v1625836434/eola/public_images/graham-background.png',
    name: 'Graham',
    role: 'Senior rails developer',
    origin: 'Suffolk, UK',
    favouriteActivityType: 'Sailing'
  },
  {
    profileImageUrl: 'v1583160650/eola/public_images/tom-faceshot.png',
    backgroundUrl: 'v1629122460/eola/public_images/tom-backgrounnd.png',
    name: 'Tom',
    role: 'Senior rails developer',
    origin: 'Sharjah, UAE',
    favouriteActivityType: 'Hiking'
  },
  {
    profileImageUrl: 'v1646392806/eola/public_images/owen-headshot.png',
    backgroundUrl: 'v1646394908/eola/public_images/owen-background.png',
    name: 'Owen',
    role: 'Partner success',
    origin: 'Torfaen, Wales',
    favouriteActivityType: 'Kayaking'
  },
  {
    profileImageUrl: 'v1707392258/eola/public_images/lucas-headshot.jpg',
    backgroundUrl: 'v1625835756/eola/public_images/christian-background.png',
    name: 'Lucas',
    role: 'Account Executive',
    origin: 'Bath, UK',
    favouriteActivityType: 'Trail running'
  },
  {
    profileImageUrl: 'v1707393405/eola/public_images/tomh-headshot.jpg',
    backgroundUrl: 'v1625836517/eola/public_images/mark-background.png',
    name: 'Tom H',
    role: 'Account Executive',
    origin: 'London, UK',
    favouriteActivityType: 'Coasteering'
  },
  {
    profileImageUrl: 'v1707392464/eola/public_images/rita-headshot.png',
    backgroundUrl: 'v1707393194/eola/public_images/rita-background.jpg',
    name: 'Rita',
    role: 'Marketing Executive',
    origin: 'Lisbon, PT',
    favouriteActivityType: 'Hiking'
  }
]
